(function ($, undefined) {

	"use strict";

	//----------------------------------------------------------------------------------------------------
	// CHECKBOX & RADIO
	//----------------------------------------------------------------------------------------------------
	function checkbox_radio() {
		$('.useCheckbox input').on('change', function () {
			var $use = $(this).parent('.useCheckbox');
			var dataPayment = $use.attr('data-payment');
			if ($use.hasClass('active'))
				$use.removeClass('active');
			else
				$use.removeClass('active').addClass('active');
			if (dataPayment !== undefined) {
				$('.dataPayment.all').css({ 'display': 'flex' });
				$('.dataPayment:not(.all)').css({ 'display': 'none' });
				$('.dataPayment.' + dataPayment).css({ 'display': 'flex' });
			}
		});
		$('.useRadio input').on('change', function () {
			var $use = $(this).parent('.useRadio');
			var name = $use.find('input[type="radio"]').attr('name');
			var dataPayment = $use.attr('data-payment');
			$('.useRadio input[name="' + name + '"]').parent('.useRadio').removeClass('active');
			$use.removeClass('active').addClass('active');
			if (dataPayment !== undefined) {
				$('.dataPayment.all').css({ 'display': 'flex' });
				$('.dataPayment:not(.all)').css({ 'display': 'none' });
				$('.dataPayment.' + dataPayment).css({ 'display': 'flex' });
			}
		});
	}
	//----------------------------------------------------------------------------------------------------
	// UseSelect
	//----------------------------------------------------------------------------------------------------
	function useSelect() {
		$('.useSelect').each(function () {
			var $useSelect = $(this);
			var selected = '';
			var val = '';
			if ($useSelect.hasClass('allProvinces')) {
				selected = $useSelect.find('select:visible option:selected').text();
				val = $useSelect.find('select:visible option:selected').val();
			} else {
				selected = $useSelect.find('select option:selected').text();
				val = $useSelect.find('select option:selected').val();
			}
			$useSelect.removeClass('selected');
			if (val !== '')
				$useSelect.addClass('selected');
			$useSelect.find('span').remove();
			$useSelect.prepend('<span>' + selected + '</span>');
		});
		$('.useSelect select').on('change', function () {
			var $select = $(this);
			var $useSelect = $select.parent('.useSelect');
			var $span = $useSelect.find('span');
			$select.find('option:selected').each(function () {
				var text = $(this).text();
				var val = $(this).val();
				$useSelect.removeClass('selected');
				if (val !== '')
					$useSelect.addClass('selected');
				$span.remove();
				$useSelect.prepend('<span>' + text + '</span>');
			});
		});
	}
    
    var setJobDate = (e) => {
        const data = $(e.currentTarget).data();
        const $form = $('.jobs-action-change-date-form');
        
        $('input[name=jobId]', $form).val(data.jobId);
        $('select[name=postedDateYear]', $form).val(data.year).trigger('change');
        $('select[name=postedDateMonth]', $form).val(data.month).trigger('change');
        $('select[name=postedDateDay]', $form).val(data.day).trigger('change');
        $('select[name=postedDateHour]', $form).val('0').trigger('change');
        $('select[name=postedDateMinute]', $form).val('0').trigger('change');
    };
    
    var submitForm = (e) => {
        const btn = e.currentTarget;
        if ($(btn).attr('disabled') === 'true') {
            e.preventDefault();
            return false;
        }
        $(btn).attr('disabled', true);
        btn.form.submit();
    };
    
    var changeStatusParam = function(e) {
        const sel = e ? e.target : this;
        const inp = sel.parentElement.querySelector('.filter-accounts-status-input');
        const param = sel.value.split(':');

        if (param.length === 0) {
            inp.name = '';
            inp.value = '';
        } else {
            inp.name = param[0];
            inp.value = param[1];
        }
    };

	var init = function (page) {
		var currPage = $(page);
		useSelect();
		checkbox_radio();
		checkInputs(currPage);
        
		$('.table-admin.sortable', currPage).tablesorter();
		$('.table-mentoring', currPage).tablesorter({
			sortList: [[2, 1]] // sort la table de mentorats par date ascending par défaut (1 = asc, 2 = desc)
		});
        
		$("*[data-sticky_column='true']", currPage).stick_in_parent();
        
        $('.table-jobs-action-change-date', currPage).on('click', setJobDate);
        $('.jobs-action-change-date-confirm', currPage).on('click', submitForm);
        
        $('.filter-accounts-status-select', currPage).on('change', changeStatusParam);
        $('.filter-accounts-status-select', currPage).each((i, el) => changeStatusParam.call(el));
        
	};

	var adminInit = function(page) {
		var adminWrapper = $('.admin-wrapper');

		if (adminWrapper.length) {
			init(page);
		}
	};

	Fw.modules.export('functions', {
		pageLoad: adminInit,
	});
})(jQuery);